import * as React from "react"
import Svg, { Rect, Path } from "react-native-svg"

function SvgComponent(props) {
  return (
    <Svg
      width={46}
      height={45}
      viewBox="0 0 46 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Rect
        x={0.575195}
        width={44.8501}
        height={44.8501}
        rx={22.425}
        fill="#FFF5F5"
      />
      <Path
        d="M23 20.001l7.487-7.487a1.412 1.412 0 111.999 1.999s0 0 0 0L24.998 22l7.487 7.487s0 0 0 0a1.412 1.412 0 010 1.998L23 20.002zm0 0l-7.487-7.487h0a1.412 1.412 0 00-1.998 0L23 20.001zm0 3.997l7.487 7.487a1.41 1.41 0 001.999 0L23 24zm0 0l-7.487 7.487-.106-.105.106.105a1.41 1.41 0 01-1.998 0 1.412 1.412 0 010-1.998L21 22l-7.486-7.487s0 0 0 0a1.412 1.412 0 010-1.999L23 24z"
        fill="#FF4D4F"
        stroke="#FF4D4F"
        strokeWidth={1}
      />
    </Svg>
  )
}

export default SvgComponent
